export const DefaultBrandValue = "default";
export const DefaultCategoryValue = "default";
export const DefaultProductValue = "default";
